<template>
  <div>
	      <Subs/>
  </div>
</template>

<script>
//import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import Subs from './SubscriptionComponent'
import router from '@/router';

export default {
  components : {
    //Navbar,
    Subs
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
  },
  mounted() {
    //this.showRemaining();
  },
  async created() {
    },
  methods: {   
  },
}
</script>

<style scoped>
.second {
    max-width: 60px;
}
</style>

